"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _FlexTabContainer = _interopRequireDefault(require("../../FlexTabContainer"));
var _Accordion = _interopRequireDefault(require("../../Accordion"));
var _utils = require("../../utils");
var _Title = _interopRequireDefault(require("../../Title"));
var _Image = _interopRequireDefault(require("../../Image"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/*
 * @Author: syd
 * @Date: 2021-02-04 04:24:59
 * @Last Modified by: syd
 * @Last Modified time: 2021-04-07 17:46:13
 */
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var TabPane = _FlexTabContainer["default"].TabPane;
// eslint-disable-next-line react/display-name
var PictureComponent = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  // let keys;
  var imageSrc = props.imageSrc,
    filedVideoBg = props.filedVideoBg,
    filedVideoList = props.filedVideoList,
    record = props.record;
  var url = (0, _utils.fomateFileData)(imageSrc).url;
  var _a = (0, _react.useState)({}),
    styles = _a[0],
    setStyls = _a[1];
  var _b = (0, _react.useState)(0),
    value = _b[0],
    setValue = _b[1];
  var _c = (0, _react.useState)(0),
    ifshow = _c[0],
    setIfshow = _c[1];
  var _d = (0, _react.useState)(0),
    hei = _d[0],
    setHei = _d[1];
  var fWidth;
  var fHeight;
  (0, _react.useEffect)(function () {
    var imgLoad = new Image();
    var collectStyles = {};
    if (url) {
      imgLoad.src = url;
    }
    imgLoad.onload = function () {
      // console.log(imgLoad, '图片路径');
      fWidth = 944 / imgLoad.width;
      fHeight = imgLoad.height * fWidth;
      setHei(fHeight);
      if (fHeight > 748) {
        setIfshow(1);
        collectStyles = {
          width: '100%',
          height: '648px'
        };
      } else {
        collectStyles = {
          height: fHeight + "px",
          width: '100%'
        };
      }
      // console.log(imgLoad.width, fHeight, 'styles');
      setStyls(collectStyles);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'framework-img',
    style: __assign({
      maxWidth: '955px'
    }, styles)
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    filedVideoList: filedVideoList,
    filedVideoBg: filedVideoBg,
    ref: ref,
    style: {
      Width: '100%',
      height: hei
    },
    source: imageSrc,
    record: record
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: ifshow == 1 ? {
      display: 'flex'
    } : {
      display: 'none'
    },
    className: value == 1 ? 'posi-open posi' : 'posi-stop posi',
    onClick: function onClick() {
      var collectStyles;
      if (value == 0) {
        setValue(1);
        collectStyles = {
          width: '100%',
          height: hei + "px"
        };
      } else {
        setValue(0);
        collectStyles = {
          width: '100%',
          height: '648px'
        };
      }
      setStyls(collectStyles);
    }
  }, value == 0 ? 'Show more' : 'Show less', /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "design-icon"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#006EFF",
    transform: "rotate(-180 12.25 12.25)",
    d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
    fillRule: "evenodd"
  }))));
});
var Scenarios = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    style = props.style,
    source = props.source,
    flexTitle = props.flexTitle,
    configuration = props.configuration,
    className = props.className,
    imageSrc = props.imageSrc,
    areaColor = props.areaColor,
    onClick = props.onClick,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "style", "source", "flexTitle", "configuration", "className", "imageSrc", "areaColor", "onClick"]);
  // 判断是否使用的样式类型 -pc or mobile
  var _a = (0, _react.useState)(true),
    currentClass = _a[0],
    setCurrentClass = _a[1];
  var pictureRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(setCurrentClass);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    className: 'flex-default-scenarios-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-scenarios-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), currentClass ? (/*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: '0 24px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], null, configuration ? configuration.map(function (item, i) {
    var _a = item,
      title = _a.title,
      key = _a.key,
      content = _a.content,
      filedVideoBg = _a.filedVideoBg,
      filedVideoList = _a.filedVideoList,
      imageSrc = _a.imageSrc,
      tabTitle = _a.tabTitle;
    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      key: i,
      tabIndex: key,
      title: tabTitle
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: 'ant-tabs-content-holder__section',
      style: {
        marginTop: configuration.length > 1 ? '24px' : '0'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'scenarios'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "s-left",
      style: (0, _typeof2["default"])(areaColor) === 'object' ? areaColor : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'title',
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'content',
      dangerouslySetInnerHTML: {
        __html: content
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: 's-right'
    }, /*#__PURE__*/_react["default"].createElement(PictureComponent, {
      ref: pictureRef,
      imageSrc: imageSrc,
      filedVideoList: filedVideoList,
      filedVideoBg: filedVideoBg,
      record: item || {}
    })))));
  }) : null))) : (/*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    configuration: configuration
  }))));
});
Scenarios.displayName = 'TCIScenarios';
var _default = exports["default"] = Scenarios;